<template>
	<div>
		<van-nav-bar
			title="上传业务凭证"
			left-arrow
			@click-left="onNavBarLeft"
		/>
		<div class="form-upload">
			<div class="form-upload-head">
				<div class="form-upload-desc">应监管要求，合同必须上传，如合同为框架合同，应有结算单并与合同一起上传。</div>
			</div>
			<van-uploader v-model="files" :after-read="afterRead" />
		</div>
		<div style="padding: 16px;">
			<van-button type="primary" color="#2f86f6" block @click="onSubmit" :disabled="submitLoading">提交</van-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'uploader_cash',
		data() {
			return {
				id : 0,
				files : [],
				submitLoading : false
			}
		},
		mounted() {
			this.id = this.$route.query.id;
		},
		methods : {
			onSubmit(){
				const filesVal = this.getArrUrls( this.files);
				if( filesVal.isUpload ){
				    this.$toast('图片上传中，请稍等...');
				    return false;
				}
				
				if( filesVal.urls.length < 1 ){
					this.$toast('请上传业务凭证');
					return false;
				}
				
				this.$post('/gtb/home/uploadEvidence.html',{ invoiceId : this.id, evidencePic : filesVal.urls }).then(res=>{
					if (res.success) {
						this.$toast.success(res.msg);
						this.$router.go(-1);
					}else{
						this.$dialog({
							title : '提示',
							message: res.msg,
						});
					}
				});
			},
			afterRead(file) {
				file.status = 'uploading';
				file.message = '上传中...';
				this.$upload({ file : file.file , dir : 'proof' }).then(url=>{
					file.status = 'done';
					file.message = '上传成功'
					file.url = url;
				}).catch(error=>{
					file.status = 'failed';
					file.message = '上传失败';
				});
			},
			getArrUrls(arr){
				let urls = [];
				for( let i = 0; i < arr.length; i++ ){
				    const item = arr[i];
				    if( item.status === 'done'){
				        urls.push(item.url);
				    }
				    if( item.status === 'uploading'){
				        return { isUpload : true }
				    }
				}
				return {
				    isUpload : false,
				    urls : urls
				};
			},
			onNavBarLeft(){
				this.$router.go(-1);
			}
		}
	}		
</script>

<style>
	.form-upload {padding: 16px;background: #fff;}
	.form-upload-head {margin-bottom: 15px;}
	.form-upload-title {margin-bottom: 5px;}
	.form-upload-desc {font-size: 12px;color: #999;}
</style>
